import { Component, OnInit, OnDestroy } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { Subscription } from 'rxjs';
import Event from 'src/app/interfaces/Event';
import { EventService } from 'src/app/services/event.service';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-events',
  templateUrl: './events.component.html',
  styleUrls: ['./events.component.scss'],
})
export class EventsComponent implements OnInit, OnDestroy {
  subscriptions: Subscription = new Subscription();
  events;
  filteredEvents;
  currentUser;
  locked = false;
  params = null;

  constructor(
    private route: ActivatedRoute,
    private userService: UserService,
    private eventService: EventService,
    private analyticsService: AnalyticsService
  ) {}

  ngOnInit() {
    this.analyticsService.event('event_view');
    this.subscriptions.add(
      this.eventService.getUnarchivedEvents().subscribe((eventsRes) => {
        this.events = eventsRes.filter((e) => !e.archived);
        this.filteredEvents = this.events;
      })
    );
    this.subscriptions.add(
      this.userService.user.subscribe((u) => {
        if (u && u.uid) {
          this.currentUser = u;
          this.locked = false;
        } else {
          this.locked = true;
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  filterChange(f) {
    this.filteredEvents = f.filteredList;
  }
}
